import { render, staticRenderFns } from "./TheIndexClasificacionCie.vue?vue&type=template&id=61bc5ca0&"
import script from "./TheIndexClasificacionCie.vue?vue&type=script&lang=js&"
export * from "./TheIndexClasificacionCie.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports